var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css, keyframes } from 'styled-components';
import themeGet from '@styled-system/theme-get';
import { Box } from '../Box';
import { Flex } from '../Flex';
import { applySizes } from '../utils';
var sizes = {
    small: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: 18px;\n\n    & > * {\n      width: 8px;\n      height: 8px;\n    }\n\n    & > :not(:last-child) {\n      margin-right: ", "px;\n    }\n  "], ["\n    height: 18px;\n\n    & > * {\n      width: 8px;\n      height: 8px;\n    }\n\n    & > :not(:last-child) {\n      margin-right: ", "px;\n    }\n  "])), themeGet('space.3')),
    medium: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    height: 21px;\n\n    & > * {\n      width: 12px;\n      height: 12px;\n    }\n\n    & > :not(:last-child) {\n      margin-right: ", "px;\n    }\n  "], ["\n    height: 21px;\n\n    & > * {\n      width: 12px;\n      height: 12px;\n    }\n\n    & > :not(:last-child) {\n      margin-right: ", "px;\n    }\n  "])), themeGet('space.4')),
    large: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    height: 24px;\n\n    & > * {\n      width: 16px;\n      height: 16px;\n    }\n\n    & > :not(:last-child) {\n      margin-right: ", "px;\n    }\n  "], ["\n    height: 24px;\n\n    & > * {\n      width: 16px;\n      height: 16px;\n    }\n\n    & > :not(:last-child) {\n      margin-right: ", "px;\n    }\n  "])), themeGet('space.4')),
};
var speeds = {
    slow: 2.5,
    medium: 2,
    fast: 1,
};
var getDelay = function (duration, pos) {
    if (pos === void 0) { pos = 0; }
    return "".concat((duration / 6) * pos, "s;");
};
var animation = keyframes(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  0%, 20%, 100% {\n    transform: translateY(50%) scale(0);\n  }\n  50% {\n    transform: translateY(-50%) scale(1);\n  }\n"], ["\n  0%, 20%, 100% {\n    transform: translateY(50%) scale(0);\n  }\n  50% {\n    transform: translateY(-50%) scale(1);\n  }\n"])));
var Container = styled(Flex)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  justify-content: center;\n  align-items: center;\n\n  ", ";\n"], ["\n  justify-content: center;\n  align-items: center;\n\n  ", ";\n"])), applySizes(sizes, null));
var Dot = styled(Box)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  border-radius: 50%;\n  transform: scale(0);\n  transform-origin: center;\n  animation: ", " ", "s ease infinite;\n  animation-delay: ", "s;\n"], ["\n  border-radius: 50%;\n  transform: scale(0);\n  transform-origin: center;\n  animation: ", " ", "s ease infinite;\n  animation-delay: ", "s;\n"])), animation, function (props) { return props.duration; }, function (props) { return getDelay(props.duration, props.pos); });
var propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([
        PropTypes.oneOf(Object.keys(sizes)),
        PropTypes.arrayOf(PropTypes.oneOf(Object.keys(sizes))),
    ]),
    speed: PropTypes.oneOf(Object.keys(speeds)),
};
var DotLoader = function (_a) {
    var color = _a.color, size = _a.size, speed = _a.speed, props = __rest(_a, ["color", "size", "speed"]);
    var duration = speeds[speed];
    return (React.createElement(Container, __assign({ size: size }, props),
        React.createElement(Dot, { color: color, duration: duration }),
        React.createElement(Dot, { color: color, duration: duration, pos: 1 }),
        React.createElement(Dot, { color: color, duration: duration, pos: 2 })));
};
DotLoader.propTypes = propTypes;
DotLoader.defaultProps = {
    color: 'primary',
    size: 'medium',
    speed: 'medium',
};
export default DotLoader;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=DotLoader.js.map